<template>
        <div class="js-product-filter t-product-filter" ref="productFilter" sticky-container>
            <section class="filter" v-sticky sticky-offset="offset" sticky-side="top">
                <div class="container">
                    <div class="row">

                        <div class="col-md-2">
                            <h3 class="filter__title">filter</h3>
                            <span class='visible-xs' if="!loading">
                                <a href="#" class='filter-toggle' @click.prevent="toggleFilter()">{{filterVisible ? 'hide' : 'show'}}</a>
                            </span>
                        </div>

                        <div class="col-md-10" v-show="filterVisible">
                            <form action="" id='form_filter' class="form-inline">

                                <div class="row">
                                    <div class="col-md-4 col-sm-4" v-show="!loading">
                                        <div class="filter__wrapper" @click="changeFilter('cat',$event)">
                                            <select name="" id="cat_filter" class="filter__select" v-model="productCategory">
                                                <option value="">show all</option>
                                                <option v-for="option in productCategories" v-if="option.node.products.edges.length" :value="option.node.slug" :key="option.node.slug">
                                                    {{option.node.name}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-md-4 col-sm-4" v-show="!loading && productCategory">
                                        <div class="filter__wrapper" @click="changeFilter('range',$event)">
                                            <select name="" id="range_filter" class="filter__select" v-model="range">
                                                <option value="">select range</option>
                                                <option v-for="option in categoryRanges" :value="option.node.slug" :key="option.node.slug">
                                                    {{option.node.name}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-md-4 col-sm-4"  v-show="!loading && range && rangesSizes">
                                        <div class="filter__wrapper" @click="changeFilter('tub',$event)">
                                            <select name="" id="tub_filter" class="filter__select" v-model="tubSize">
                                                <option value="">select tub size</option>
                                                <option v-for="option in rangesSizes" :value="option.size" :key="option.size">
                                                    {{option.size}}{{(range === 'kefir') ? 'ml' : 'g'}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <a v-show="!loading && (productCategory || range || tubSize)" id='view-all-btn' class='btn btn-yellow' style="display: inline-block; opacity: 1;" @click="clearFilters">clear filter</a>

                                    <div id='loader' v-if="loading">
                                        <div class="cssload-container">
                                            <div class="cssload-speeding-wheel"></div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            <template v-for="range in ranges">
                <section class="product-range t-product-filter__range  fade-in" v-for="(size, index) in filterProducts(range.node.sizes, range.node.slug)" :key="`${range.node.slug}-${size.size}`" v-if="range.node.products.edges.length > 0" :class="[`t-product-filter__range--range_${range.node.slug}`,{'is-not-first':(index!==0)}]">
                    <div class="container">
                        <div v-if="index===0" class="row">
                            <div class="col-sm-8 col-sm-offset-2 col-md-8 col-md-offset-2">
                                <h2 class="section-title">{{range.node.name}}</h2>
                                
                                <p class="section-text" v-html="range.node.description"></p>
                            </div>
                        </div>
                        <div class='section-content'>
                            <product-swiper inline-template :range="range" :size="size" :products="size.products">
                                <div :class="{'is-centered':isCentered}">
                                    <div ref="swiperContainer" class='row category-products text-center swiper-container'>
                                        <h3 v-if="range.node.sizes.length > 1 && size.size">{{size.size}}{{(range.node.slug === 'kefir') ? 'ml' : 'g'}}</h3>
                                        <div  class='t-product-filter__swiper-wrapper swiper-wrapper'>
                                            <div v-for="product in size.products" :key="product.node.link" class='t-product-filter__image category-product swiper-slide' :class="['t-product-filter__image--range_'+range.node.slug, 't-product-filter__image--product_'+product.node.slug]">
                                                <div class='inner'>
                                                    <a :href='product.node.link'><img :src="product.node.featuredImage.sourceUrl" alt="" class="t-product-filter__image img-responsive"></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                
                                    <div ref="swiperButtonPrev" class="swiper-button-prev"></div>
                                    <div ref="swiperButtonNext" class="swiper-button-next"></div>
                                </div>
                            </product-swiper>
                        </div>

                    </div>
                </section>
            </template>
        </div>
</template>

<script>

    import axios from 'axios';
    import { find, chain } from 'lodash';
    //import VueSticky  from 'vue-sticky';
    import Sticky from 'vue-sticky-directive'
    import ProductSwiper from './product-swiper.vue';

    // todo: populate this from taxonomy fields
    const pairings ={
        // 'kefir':['yoghurt', 'just-out'],
        // 'suckies':['kids'],
        // 'gourmet':['yoghurt'],
        // 'unsweetened':['yoghurt'],
        // 'pro-yo':['yoghurt'],
        // 'duples':['yoghurt'],

        'gourmet-yoghurt':['yoghurt'],
        'greek':['yoghurt'],
        'haloumi':['haloumi-and-labneh'],
        'kefir':['yoghurt'],
        'labneh-dips':['haloumi-and-labneh'],
        'organic-lil-suckies':['kids-yoghurt'],
        'pourable':['yoghurt'],
        'pro-yo-skyr':['yoghurt'],
        'probots':['kids-yoghurt'],
        'straight-up':['yoghurt'],
        'suckies':['kids-yoghurt'],
        'suckies-multiboxes':['kids-yoghurt']

    }

export default {
    components:{
        'product-swiper': ProductSwiper
    },
    directives:{
        Sticky
    },
    methods:{
        handleHash(){
            // check if hash exists in product categories,
            // then check if hash exists in ranges
            
            //console.log('handleHash', this.hash, this.categoryRanges, this.ranges)

            if(this.hash){

                let category = find(this.productCategories,[['node','slug'], this.hash] );
                let range = find(this.ranges,[['node','slug'], this.hash]);

                if(category){
                    this.productCategory = category.node.slug
                } else if(range){
                    //console.log(pairings[range.node.slug][0], '->',range.node.slug)
                    
                    this.productCategory = pairings[range.node.slug][0];
                    this.range = range.node.slug;

                }

                this.$nextTick(()=>{
                    setTimeout(()=>{
                        this.$refs.productFilter.scrollIntoView({alignToTop:true,behavior:'smooth'})
                    }, 1);
                });
            }
        },
        toggleFilter(){
            if(this.filterVisible){
                this.filterVisible = false;
            } else {
                this.filterVisible = true
            }
        },
        changeFilter(filter, event){
            
            //console.log('changeTo!', filter, event.target.dataset.value);

            if(event.target.dataset.value !== undefined){
                //console.log('changeTo!', filter, event.target.dataset.value);
                if(filter==="cat"){
                    this.productCategory = event.target.dataset.value;
                } else if(filter==="range"){
                    this.range = event.target.dataset.value;
                } else if(filter==="tub"){
                    this.tubSize = event.target.dataset.value;
                }
            }
            
        },
        clearFilters(){
            this.productCategory = '';
            this.range = '';
            this.tubSize = '';

            this.$nextTick(()=>{
                window.jQuery('#tub_filter').niceSelect('update');
                window.jQuery('#cat_filter').niceSelect('update');
                window.jQuery('#range_filter').niceSelect('update');
            });
        },
        filterProducts(sizes, rangeSlug){


            let filteredSizes = sizes.filter((size)=>{
                if(this.tubSize !== '' && this.tubSize !== size.size){
                    return;
                } else if(this.range !== '' && this.range !== rangeSlug){
                    return;
                } else if (this.productCategory !== '' && pairings[rangeSlug].indexOf(this.productCategory) === -1){
                    // check if range is in 
                    return
                } else {
                    return true;
                }
            });


            // if tubSize is not selected, merge them down into one size
            if(this.tubSize || filteredSizes.length === 0){
                return filteredSizes;
            } else {
                return [{
                    size: '',
                    products: filteredSizes.reduce((arr,val)=>{ return arr.concat(val.products)},[])
                }]
            }
            
        }
    },     
    data(){
        return {
            loading: true,
            offset:{
                top: 60
            },
            hash: '',
            //
            foo: 'bar',
            productCategories:[],
            ranges: [],
            //
            productCategory:"",
            range: "",
            tubSize: "",
            //
            filterVisible:true
        }
    },
    computed:{
        categoryRanges(){
            let ranges = [];
            
            // show range if 

            this.ranges.forEach((range)=>{
                //console.log(range)
                if(pairings[range.node.slug].indexOf(this.productCategory) !== -1 || this.productCategory === ''){
                    if(range.node.products.edges.length > 0){
                            ranges.push(range);
                    }
                    //ranges.push(range);
                }
            });

            return ranges;

        },
        rangesSizes(){
            
            // if sizes, then return sizes or return nothing/

            let range = find(this.ranges, {node:{slug:this.range}});

            if(range === undefined){
                return "";
            } else if(range.node.sizes.length > 1){
                return range.node.sizes;
            } else {
                return "";
            }
            
        }
    },
    watch:{
        productCategories(){
            this.$nextTick(()=>{
                window.jQuery('#cat_filter').niceSelect('update');
            });
        },
        productCategory(newVal){
            if(this.range && pairings[this.range].indexOf(newVal) === -1){
                this.range = '';
            }
            
            this.tubSize = '';
        },
        categoryRanges(){
            this.$nextTick(()=>{
                window.jQuery('#range_filter').niceSelect('update');
            });
        },
        range(){
            this.tubSize = '';
            this.$nextTick(()=>{
                window.jQuery('#range_filter').niceSelect('update');
            });
        },
        rangesSizes(){
            this.$nextTick(()=>{
                window.jQuery('#tub_filter').niceSelect('update');
            });
        }
    },
    filters:{
        json: (value) => { return JSON.stringify(value, null, 2) }
    },
    created(){

        var hash = window.location.hash; 

        if(hash){
            this.hash = hash.replace('#', '');
            //this.handleHash();
        }

        let query = `{product_categories{edges{node{name,slug,products{edges{node{slug}}}}}},ranges(first:999){edges{node{name,description,slug,products(first:999){edges{node{pack_size,link,slug,featuredImage{sourceUrl}}}}}}}}`;

        axios.get(`/graphql?query=${query}`).then((response) => {

            this.loading = false;

            this.productCategories = response.data.data.product_categories.edges;
            this.ranges = response.data.data.ranges.edges;

            this.ranges.forEach((range)=>{
                
                range.node.sizes  = chain(range.node.products.edges)
                    .groupBy('node.pack_size')
                    .map((value, key)=>{
                        return {size: key, products: value}
                    })
                    .orderBy('size', 'desc')
                    .value()

            });

            this.handleHash();

        })
    },
    mounted(){

        if(this.hash){
            this.$refs.productFilter.scrollIntoView({alignToTop:true,behavior:'smooth'})

            if(window.innerWidth < 768){
                this.filterVisible = false
            }
        }

        this.$nextTick(()=>{

            window.jQuery(document).ready(function() {
                window.jQuery(function($) {
                    $('#tub_filter').niceSelect();
                    $('#cat_filter').niceSelect();
                    $('#range_filter').niceSelect();
                })
            });
        });
    },
    replace: false
}
</script>

<style lang="sass">
// BEM helper functions  
=e($name)
  @at-root #{&}__#{$name}
    @content
=m($name)
  @at-root #{&}--#{$name}
    @content

// brand variables
$brand-light: #FEFCE1;
$brand-dark: #191E24;
$brand-blue: #00A5DF;

// some one off overide classes
.footer
  +e(link)
    color: $brand-light
    text-decoration: underline
    &:hover
      color: $brand-blue

.t-product-filter  
    min-height: 300px;
    background-color: $brand-light

    .is-centered
        .t-product-filter__swiper-wrapper
            justify-content: center;
            transform: translate3d(0px, 0px, 0px) !important;
        .swiper-button-prev
            display: none
        .swiper-button-next
            display: none
    +e(range)
        &.is-not-first
            padding-top: 10px !important;
        h3
            margin-bottom: 0;

        +m(range_kefir)
            padding-bottom: 0 !important;
            &:after
                height: 110px !important;
    +e(image)
        img
            margin: auto;
            max-height: 300px;
        +m(range_kefirs)
            a
                overflow: hidden !important
            img
                transform: scale(1.5) !important

#kefir-our-range
    min-height: 300px;


.fade-in
	opacity: 1;
	animation: fadeInOpacity 0.3s ease;

@keyframes fadeInOpacity
	0%
		opacity: 0;
	100%
		opacity: 1;
</style>
